import { render, staticRenderFns } from "./P020.vue?vue&type=template&id=aee77010"
import script from "./P020.vue?vue&type=script&lang=js"
export * from "./P020.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports